<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>

  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png" /> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>
    <p-tabView>
      <p-tabPanel header="Upload Files">
        <div class="card cost-api-card" style="padding: 2rem; margin-left: 1rem">
          <p style="font-weight: bold">Sales and Volume:</p>
          <form [formGroup]="fileUploadForm" (ngSubmit)="onFormSubmit()">
            <div class="row">
              <div class="text-center col-sm-6 col-md-6 col-lg-4">
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="customFile" name="myfile"
                    (change)="onFileSelect($event)" #UploadFileInput />
                  <label class="custom-file-label" for="customFile">{{fileInputLabel || 'Choose File'}}</label>
                </div>
              </div>
              <div class="text-center">
                <button class="btn btn-primary" type="submit">
                  <i class="fa fa-upload mr-2"></i>Upload
                </button>
              </div>
            </div>
          </form>

          <div class="row table-responsive" style="
              margin-top: 20px;
              width: 85rem !important;
              height: 800px !important;
            ">
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>

</div>